export class GetCancerScreeningInfoModel {
  patientCancerScreeningInfo?: PatientCancerScreeningInfo;

  constructor(i: any) {
    this.patientCancerScreeningInfo = i.patientCancerScreeningInfo
      ? new PatientCancerScreeningInfo(i.patientCancerScreeningInfo)
      : undefined;
  }
}

export class PatientCancerScreeningInfo {
  age?: string;
  address?: string;
  ssn?: string;
  visits?: PatientVisits[];
  status?: PatientStatus[];
  constructor(i: any) {
    this.age = i.age ? i.age : undefined;
    this.address = i.address ? i.address : undefined;
    this.ssn = i.ssn ? i.ssn : undefined;
    this.visits = i.visits
      ? i.visits.map((item: any) => new PatientVisits(item))
      : undefined;
    this.status = i.status
      ? [
          new PatientStatus(
            "Dag. síðustu komu",
            i.status?.komuDagur,
            i.status?.komuDagurBrj
          ),
          new PatientStatus(
            "Boðunartíðni",
            i.status?.bodunarTidni,
            i.status?.bodunarTidniBrj
          ),
          new PatientStatus(
            "Eftirlit",
            i.status?.eftirlit,
            i.status?.eftirlitBrj
          ),
        ]
      : undefined;
  }
}

export class PatientVisits {
  date?: string;
  resultHtml: string;
  type: string;
  constructor(i: any) {
    this.date = i.date ? i.date : undefined;
    this.resultHtml = i.resultHtml ? i.resultHtml : "";
    this.type = i.type ? i.type : "";
  }
}

export class PatientStatus {
  translationKey: string;
  cervix: string;
  breast: string;
  constructor(title: string, cervix?: string, breast?: string) {
    this.translationKey = title;
    this.cervix = cervix || "";
    this.breast = breast || "";
  }
}
